import type { z } from 'zod'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import type { sliceValueSchema } from './schema'
import { getSimpleValue } from './simpleValue'

export const getSliceValue = ({
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly schema: z.infer<typeof sliceValueSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): string => {
  const value = getSimpleValue({
    schema: schema.value,
    transaction,
    relatedAddresses,
  })
  return value.slice(schema.start, schema.end)
}
